import api from "./client";

export async function getProductionOrderCost(id) {
  const res = await api.get(`/cost/production-order/${id}`);
  return res.data.data;
}

export async function getProductionOrderCostByOrderNo(orderNo) {
  const res = await api.get(
    `/cost/production-order/by-order-no/${encodeURIComponent(orderNo)}`
  );
  return res.data.data;
}
